/**
 * Utility function to get resolved data from PromiseSettledResult
 * @param result - PromiseSettledResult coming from Promise.allSettled()
 * @param defaultValue - default value when the Promise is rejected instead of fullfilled
 */
export const resolved = <T>(
  result: PromiseSettledResult<T>,
  defaultValue?: T,
): T => {
  if (result.status === 'fulfilled') {
    return result.value;
  }

  return defaultValue ?? undefined;
};
